import React from 'react';
import { Icon } from "@iconify/react/dist/iconify.js";
import { NavLink, useLocation } from "react-router-dom";
import './AdminNavigation.css';

const UserNavigation = ({ userType }) => {
  // userType can be 'admin' or 'superuser'
  
  const isSuperUser = userType === 'superuser';
  const isAdmin = userType === 'admin';
  const isUser = userType === 'user';
  const location = useLocation();
  
  return (
    
    <>
      
      {isUser && (
        <ul className="sidebar-menu" id="sidebar-menu">
          {/* Dashboard */}
          <li>
            <NavLink
              to='/user-dashboard'
              className={(navData) => navData.isActive ? "active-page" : ""}
            >
              <Icon icon='solar:home-smile-angle-outline' className='menu-icon' />
              <span>Dashboard</span>
            </NavLink>
          </li>

          {/* Section Title */}
          <li className="sidebar-menu-title">License Management</li>
          {/* Customer Management */}

            <li>
                <NavLink
                to='/admin/customers'
                className={(navData) => location.pathname === '/admin/customers' || location.pathname === '/admin/customers/create' ? "active-page" : ""}
                >
                <Icon icon='mdi:domain' className='menu-icon' />
                <span>Customers</span>
                </NavLink>
            </li>
          
          {/* License Items */}
            <li>
                <NavLink
                to='/admin/licenses'
                className={(navData) => location.pathname === '/admin/licenses' || location.pathname === '/admin/licenses/create' ? "active-page" : ""}
                >
                <Icon icon='mdi:license' className='menu-icon' />
                <span>Licenses</span>
                </NavLink>
            </li>

            <li>
                <NavLink
                to='/admin/mac-requests'
                className={(navData) => navData.isActive ? "active-page" : ""}
                >
                <Icon icon='mdi:swap-horizontal' className='menu-icon' />
                <span>MAC Requests</span>
                </NavLink>
            </li>

            <li>
                <NavLink
                to='/admin/licenses/revoked'
                className={(navData) => navData.isActive ? "active-page" : ""}
                >
                <Icon icon='mdi:cancel' className='menu-icon' />
                <span>Revoked Licenses</span>
                </NavLink>
            </li>

            {/* Section Title */}
            <li className="sidebar-menu-title">Reports</li>

            {/* Report Items */}
            <li>
              <NavLink
                to='/admin/reports/license-expiry'
                className={(navData) => navData.isActive ? "active-page" : ""}
              >
                <Icon icon='mdi:calendar-clock' className='menu-icon' />
                <span>License Expiry</span>
              </NavLink>
            </li>

        </ul>
      )}


    </>



  );
};

export default UserNavigation;
